import { Button, FormControlLabel, FormGroup, FormCheckbox } from 'components/common';
import { FormProvider, useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { PageURL } from 'router/pageURL';
import { ApplicationFormPageEnum } from '../types';
import { ICritereaForm } from './types';

export const Criteria = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const intl = useIntl();
  const form = useForm<ICritereaForm>({
    defaultValues: {
      bankruptcy: true,
      repossession: true,
      ccj: true,
      debtRelief: true,
      dmp: true,
      taxResident: true,
      minimumDeposit: true,
      minorTrafficOffence: true,
    },
  });

  const formState = form.watch();
  const isAnyTermNotAccepted = Object.values(formState).some(value => !value);

  const submitFormHandler = () => {
    searchParams.set('section', ApplicationFormPageEnum.BASIS);

    !isAnyTermNotAccepted && setSearchParams(searchParams);
  };

  return (
    <div>
      <FormattedMessage id={'applicationForm.CRITERIA.header1'} tagName={'h4'} />

      <FormattedMessage
        id={'applicationForm.CRITERIA.subHeader'}
        values={{
          a: text => (
            <a target={'_blank'} rel={'noreferrer'} href={PageURL.FAQ}>
              {text}
            </a>
          ),
        }}
        tagName={'p'}
      />

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submitFormHandler)}>
          <FormGroup>
            <FormControlLabel
              control={<FormCheckbox name={'bankruptcy'} />}
              label={intl.formatMessage({ id: 'applicationForm.CRITERIA.options.bankruptcy' })}
            />
            <FormControlLabel
              control={<FormCheckbox name={'repossession'} />}
              label={intl.formatMessage({ id: 'applicationForm.CRITERIA.options.repossession' })}
            />
            <FormControlLabel
              control={<FormCheckbox name={'ccj'} />}
              label={intl.formatMessage({ id: 'applicationForm.CRITERIA.options.ccj' })}
            />
            <FormControlLabel
              control={<FormCheckbox name={'debtRelief'} />}
              label={intl.formatMessage({ id: 'applicationForm.CRITERIA.options.debtRelief' })}
            />
            <FormControlLabel
              control={<FormCheckbox name={'dmp'} />}
              label={intl.formatMessage({ id: 'applicationForm.CRITERIA.options.dmp' })}
            />
            <FormControlLabel
              control={<FormCheckbox name={'taxResident'} />}
              label={
                <FormattedMessage
                  id={'applicationForm.CRITERIA.options.taxResident'}
                  values={{
                    a: text => (
                      <a target={'_blank'} rel={'noreferrer'} href={PageURL.RECIDENCY_REQUIREMENTS}>
                        {text}
                      </a>
                    ),
                  }}
                />
              }
            />
            <FormControlLabel
              control={<FormCheckbox name={'minimumDeposit'} />}
              label={
                <FormattedMessage
                  id={'applicationForm.CRITERIA.options.minimumDeposit'}
                  values={{
                    a: text => (
                      <a target={'_blank'} rel={'noreferrer'} href={PageURL.INCOME_REQUIREMENTS}>
                        {text}
                      </a>
                    ),
                  }}
                />
              }
            />
            <FormControlLabel
              control={<FormCheckbox name={'minorTrafficOffence'} />}
              label={intl.formatMessage({ id: 'applicationForm.CRITERIA.options.minorTrafficOffence' })}
            />
          </FormGroup>
          <div className={'mt-8 flex justify-end'}>
            <Button type={'submit'} variant={'contained'} disabled={isAnyTermNotAccepted}>
              <FormattedMessage id={'cta.continue'} />
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
